import {
  DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_BEGIN,
  DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_SUCCESS,
  DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_FAILURE,
  DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function getCollectionsByAppwrite(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/appwrites/get-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_FAILURE,
            data: { error: err },
          });
          toast.error(err.message);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetCollectionsByAppwriteError() {
  return {
    type: DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_BEGIN:
      return {
        ...state,
        getCollectionsByAppwritePending: true,
        getCollectionsByAppwriteError: null,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_SUCCESS:
      return {
        ...state,
        getCollectionsByAppwritePending: false,
        getCollectionsByAppwriteError: null,
        collectionsByAppwrite: action.data,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_FAILURE:
      return {
        ...state,
        getCollectionsByAppwritePending: false,
        getCollectionsByAppwriteError: action.data.error,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_DISMISS_ERROR:
      return {
        ...state,
        getCollectionsByAppwriteError: null,
      };

    default:
      return state;
  }
}
